var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { PeriodSectionBody } from '../common/periodSectionBody';
import { PeriodSectionTable } from '../common/periodSectionTable';
import { getLobExpansionKey, getMultiskillExpansionKeys, getMultiskillGroupExpansionKeys, getMultiskillSectionExpansionKey, getQueueExpansionKeysForLob, } from '../common/queueRow';
import { WORKLOAD_AND_PERFORMANCE_ROWS } from '../constants';
export var WorkloadAndPerformanceTable = function (_a) {
    var _b, _c;
    var data = _a.data, index = _a.index, addColumns = _a.addColumns, isProdHoursPlan = _a.isProdHoursPlan, scenarioSelector = _a.scenarioSelector;
    var t = useTranslation('report', { keyPrefix: 'period' }).t;
    var hasAnyAbandonable = !!((_b = data.queues) === null || _b === void 0 ? void 0 : _b.some(function (q) { return q.isAbandonable; }));
    var rowItems = hasAnyAbandonable
        ? WORKLOAD_AND_PERFORMANCE_ROWS
        : WORKLOAD_AND_PERFORMANCE_ROWS.filter(function (k) { return k !== 'abandonmentRate'; });
    var lobs = (_c = data.queuesByLob) !== null && _c !== void 0 ? _c : [];
    var getNestedExpansionItems = function (itemName) {
        if (rowItems.includes(itemName)) {
            var rowItem_1 = itemName;
            return lobs
                .flatMap(function (lob) { return __spreadArray([getLobExpansionKey(lob.lobName, rowItem_1)], getQueueExpansionKeysForLob(lob, rowItem_1), true); })
                .concat(getMultiskillExpansionKeys(data.queues, rowItem_1));
        }
        var multiskillRowItem = rowItems.find(function (item) { return itemName === getMultiskillSectionExpansionKey(item); });
        if (multiskillRowItem)
            return getMultiskillGroupExpansionKeys(data.queues, multiskillRowItem);
        var rowItem = rowItems.find(function (item) { return itemName.startsWith("".concat(item, "::")); });
        if (!rowItem)
            return [];
        var lobEntry = lobs.find(function (lob) { return itemName === getLobExpansionKey(lob.lobName, rowItem); });
        if (!lobEntry)
            return [];
        return getQueueExpansionKeysForLob(lobEntry, rowItem);
    };
    return (_jsx(PeriodSectionTable, { title: t('workloadAndPerformance'), data: data, index: index, addColumns: addColumns, isProdHoursPlan: isProdHoursPlan, expansionItems: __spreadArray(__spreadArray([], rowItems, true), rowItems.flatMap(function (item) {
            return lobs
                .flatMap(function (lob) { return __spreadArray([getLobExpansionKey(lob.lobName, item)], getQueueExpansionKeysForLob(lob, item), true); })
                .concat(getMultiskillExpansionKeys(data.queues, item));
        }), true), defaultExpanded: false, firstHeader: true, tableBodyComponent: function (props) { return _jsx(PeriodSectionBody, __assign({}, props, { rowItem: rowItems })); }, scenarioSelector: scenarioSelector, getNestedExpansionItems: getNestedExpansionItems }));
};
